import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-delete-menu-dialog',
  templateUrl: './delete-menu-dialog.component.html',
  styleUrl: './delete-menu-dialog.component.scss'
})
export class DeleteMenuDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteMenuDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      menuName: string;
      menuId: number;
    }
  ) {
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirmDelete() {
    this.dialogRef.close(true);
  }
}
